"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React from "react";
import { FaArrowDown } from "react-icons/fa";
import { getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
type Team = {
  name: string;
  short?: string; // initials fallback for logo
  logoUrl?: string; // public path if exists
  score?: string; // e.g., "120/2" or "-----"
  overs?: string; // e.g., "10.4 ov"
  badgeBg?: string; // tailwind bg for avatar backdrop
};
type Match = {
  venue: string;
  schedule: string; // small header line above the card
  statusPill?: string; // e.g., "நேரலை"
  teams: [Team, Team];
};
type Props = {
  title?: string;
  matches?: Match[];
  className?: string;
  imageMetadata?: ImageMetadata;
};

// Default content closely matching the provided screenshot
const DEFAULT_MATCHES: Match[] = [{
  schedule: "குவாலியாபூர் 1 மே, முதல் 23 (இரவு) 7:30 மணி வரை",
  venue: "சிவாஜி பார்க், நாக்பூர்",
  statusPill: "வாழ்ந்",
  teams: [{
    name: "டெல்லி தலையர்கள்கள்",
    short: "DD",
    logoUrl: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    score: "120/2",
    overs: "10.4 ov",
    badgeBg: "from-[#FF7A59] to-[#9E1F63]"
  }, {
    name: "கொல்கத்தா நைட் ரைடர்ஸ்",
    short: "KKR",
    logoUrl: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    score: "-----",
    overs: "",
    badgeBg: "from-[#44C0F1] to-[#0B74B5]"
  }]
}, {
  schedule: "குவாலியாபூர் 2 மே, முதல் 23 (இரவு) 7:30 மணி வரை",
  venue: "சிவாஜி பார்க், நாக்பூர்",
  statusPill: "வாழ்ந்",
  teams: [{
    name: "சென்னையின் சூப்பர் கிங்ஸ்",
    short: "CSK",
    logoUrl: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    score: "200/2",
    overs: "10.4 ov",
    badgeBg: "from-[#FFD95A] to-[#C58900]"
  }, {
    name: "ராஜஸ்தான் ராயல்ஸ்",
    short: "RR",
    logoUrl: "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png",
    score: "-----",
    overs: "",
    badgeBg: "from-[#FF8BBA] to-[#6A1B9A]"
  }]
}];
export default function SportsScroreCardHor(t0) {
  const $ = _c(11);
  const {
    title: t1,
    matches: t2,
    className: t3
  } = t0;
  const title = t1 === undefined ? "\u0BB5\u0BBF\u0BB3\u0BC8\u0BAF\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1 \xB7 \u0B95\u0BBF\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BC6\u0B9F\u0BCD \u0BB2\u0BC8\u0BB5\u0BCD" : t1;
  const matches = t2 === undefined ? DEFAULT_MATCHES : t2;
  const className = t3 === undefined ? "" : t3;
  const t4 = "relative w-full max-w-sm overflow-hidden bg-012061" + className;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FaArrowDown size={14} aria-hidden="true" className="text-FFFFFF " />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== title) {
    t6 = <div className="p-4 border-b border-2D497E"><div className="flex items-center gap-2">{t5}<span className="text-12-tamil-900 text-FFFFFF">{title}</span></div></div>;
    $[1] = title;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== matches) {
    t7 = matches.map(_temp2);
    $[3] = matches;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t7) {
    t8 = <div className="px-4 py-12 bg-gradient-dark-blue"><div className="grid grid-cols-1 gap-10">{t7}</div></div>;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t4 || $[8] !== t6 || $[9] !== t8) {
    t9 = <div className={t4}>{t6}{t8}</div>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}
function _temp2(m, idx) {
  return <div key={idx} className="space-y-2"><div className="text-12-tamil-900 text-FFFFFF leading-[1.4] clamp-1">{m.schedule}</div><div className="bg-020202 border-2D497E border-[1px]"><div className="flex items-center justify-between px-4 py-3 border-b border-2D497E"><div className="text-12-tamil-900 text-FFFFFF clamp-1">{m.venue}</div>{m.statusPill ? <span className="bg-B9251C text-FFFFFF text-12-tamil-900 rounded-[35px] px-3 py-1">{m.statusPill}</span> : null}</div><div className="p-4">{m.teams.map(_temp)}</div></div></div>;
}
function _temp(t, i, arr) {
  return <React.Fragment key={i}><div className="flex items-center gap-3"><Avatar team={t} /><div className="flex-1 min-w-0"><div className="text-12-tamil-900 truncate text-FFFFFF leading-[1.4] clamp-1">{t.name}</div></div><div className="text-right grid grid-rows-2 gap-1"><div className="text-16-english-900 text-FFFFFF leading-none clamp-1">{t.score ?? "-"}</div>{t.overs ? <div className="text-10-english-600 text-FFFFFF clamp-1">{t.overs}</div> : <div className="text-11-english-600 text-FFFFFF clamp-1"> </div>}</div></div>{i === 0 && arr.length > 1 && <div className="flex justify-left ml-12 my-1"><Image src="https://media.dinamani.com/dinamani/2026-02-27/md38oy88/VS.png" alt="vs" width={40} height={40} className="h-5 w-auto" /></div>}</React.Fragment>;
}
function Avatar(t0) {
  const $ = _c(4);
  const {
    team
  } = t0;
  let t1;
  if ($[0] !== team.logoUrl || $[1] !== team.name || $[2] !== team.short) {
    t1 = <div className="relative h-9 w-9 rounded-full overflow-hidden ring-1 ring-white/20 flex items-center justify-center">{team.logoUrl ? <Image src={team.logoUrl} alt={team.name} fill={true} sizes="36px" className="object-cover mix-blend-screen opacity-90" /> : <span className="relative z-10 text-10-english-800">{team.short ?? ""}</span>}</div>;
    $[0] = team.logoUrl;
    $[1] = team.name;
    $[2] = team.short;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

// Minimal chevron-down icon to mirror screenshot
function ChevronDown(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <polyline points="6 9 12 15 18 9" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{t2}</svg>;
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}